import { createVuetify } from 'vuetify'
import { VBtn } from 'vuetify/components';

const vuetifyOptions = {
  aliases: {
    VSmallIconBtn: VBtn,
  },
  defaults: {
    VMenu: {
      zIndex: 2000,
    },
    VDialog: {
      zIndex: 2400,
      VCard: {
        rounded: 'lg',
        VCardText: {
          style: {
            fontSize: '0.9rem',
            lineHeight: '1.4rem',
          },
        },
        VCardTitle: {
          class: 'dialog-title d-flex align-center justify-content-between',
          VBtn: {
            variant: 'flat',
            class: 'bg-primary-darker',
            size: 'small',
            rounded: 'circle',
            icon: true,
          },
        },
      },
    },
    VTabs: {
      bgColor: 'list',
      color: 'on-list',
      height: 48,
      style: {
        minHeight: '48px',
      },
      VTab: {
        color: 'primary',
        baseColor: 'tab-inactive',
        rounded: 0,
        style: 'padding: 0 16px',
      },
    },
    VCheckbox: {
      color: 'primary',
      density: 'comfortable',
    },
    VCheckboxBtn: {
      color: 'primary',
      density: 'comfortable',
    },
    VRadioGroup: {
      color: 'primary',
      density: 'comfortable',
    },
    VRadio: {
      color: 'primary',
      density: 'comfortable',
    },
    VIcon: {
      size: '24px',
    },
    VCard: {
      rounded: 'lg'
    },
    VField: {
      variant: 'solo-filled',
      density: 'comfortable',
      style: {
        borderRadius: '10px',
      }
    },
    VBtn: {
      height: 48,
      slim: true,
      style: {
        fontSize: '1rem',
        fontWeight: 500,
        letterSpacing: '.0892857143em',
        textTransform: 'capitalize !important',
      },
    },
    VInput: {
      VField: {
        variant: 'solo-filled',
      },
    },
    VTextField: {
      variant: 'solo-filled',
      density: 'comfortable',
      persistentCounter: true,
    },
    VList: {
      bgColor: 'list',
      color: 'on-list',
      borderRadius: '10px',
    },
    VChip: {
      class: 'px-3',
    },
    VListItemTitle: {
      lineHeight: 1.4,
    },
    VDatePicker: {
      VBtn: {
        height: undefined,
        rounded: 'circle',
      }
    },
    VCardTitle: {
      VBtn: {
        height: 36,
      },
    },
    VSlideGroup: {
      VBtn: {
        style: undefined,
      },
    },
    VSmallIconBtn: {
      size: 'small',
      density: 'comfortable',
      variant: 'text',
      height: 28,
      icon: true,
      tile: true,
      rounded: '28',
      VIcon: {
        size: 20,
        tile: true,
        opacity: 0.64
      }
    },
    VSelect: {
      density: 'comfortable',
    },
    VTreeview: {
      bgColor: 'rgba(0,0,0,0)',
      VBtn: {
        density: 'comfortable',
        size: 32,
      },
    },
    VSnackbar: {
      zIndex: 10000,  // Make the snackbar stand out
    },
    VAppBar: {
      rounded: 0,
    },
  },
  theme: {
    layers: true,
    defaultTheme: 'dark',
    themes: {
      dark: {
        dark: true,
        colors: {
          primary: '#3dabff', // VB blue
          'on-primary': '#000000',
          'primary-darker': '#0076d1',
          'on-primary-darker': '#ffffff',
          surface: '#232b36',
          'tw-surface': '#232b36',
          'tw-surface-accent': '#2f3640',
          'surface-variant': '#555555',
          'on-surface-variant': '#ffffff',
          background: '#14171b',
          secondary: '#6496c8', // VB Blue Secondary
          accent: '#3F51B5',
          info: '#125b95',
          error: '#ff5757',
          'error-darker': '#733333',
          'danger-darker': '#733333',  // An alias for "error-darker" with more contextual meaning.
          success: '#45a549',
          secondaryButtons: '#45555c',    // buttons on the second top bar
          sliderTrackColor: '#14171b',    // The color of the unfilled sliders
          podSidemenuButtons: "#2f3640",  // Pod Sidemenu top toggle buttons
          'list': '#1E1E1E',
          'tab-inactive': '#888888',
          'on-list': '#ffffff',
          footer: '#272727',
          'on-footer': '#ffffff',
        },
        variables: {
          'hover-opacity': 0.08
        }
      },
      light: {
        dark: false,
        colors: {
          primary: '#3dabff', // VB blue
          'on-primary': '#000000',
          'on-primary-variant': '#ffffff',
          'primary-darker': '#0076d1',
          'on-primary-darker': '#ffffff',
          surface: '#ffffff',
          'tw-surface': '#ffffff',
          'tw-surface-accent': '#e6ecf1',
          'surface-variant': '#616161',
          'on-surface-variant': '#ffffff',
          background: '#e6ecf1',
          secondary: '#6496c8', // VB Blue Secondary
          secondaryButtons: '#a6c4d3',    // buttons on the second top bar
          sliderTrackColor: '#e6ecf1',    // The color of the unfilled sliders
          podSidemenuButtons: "#e6ecf1",  // Pod Sidemenu top toggle buttons
          error: '#b30000',
          success: '#2e6f31',
          'error-darker': '#733333',
          'danger-darker': '#733333',
          'list': '#ffffff',
          'list-title': '#000000',
          'tab-inactive': '#757575',
          'on-list': '#000000',
          footer: '#f5f5f5',
          'on-footer': '#000000',
        },
        variables: {
          'hover-opacity': 0.08,
          'medium-emphasis-opacity': 0.7
        }
      },
    }
  },
};

export const DEFAULT_THEME_COLORS = Object.freeze(Object.fromEntries(
  Object.entries(vuetifyOptions.theme.themes).map(([name, theme]) => [
    name, Object.freeze({ ...theme.colors }),
  ]),
));

export default createVuetify(vuetifyOptions);
